import classNames from 'classnames'

import { STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'
import { generateEDDLabel } from '@src/quince-site-common/src/hooks/edd/utils/edd.utils'
import { EDDDetails } from '@src/quince-site-common/src/services/eddService/eddService.types'

import { TSocialProofData } from '../product-card.types'

import styles from './product-card-footer.module.scss'

export function BottomTagComponent({
  isPreorder,
  isWhiteGloveDelivery,
  eddDetails,
  isVitamin,
  optionValueCount,
  socialProofData,
  isOOS,
}: {
  isPreorder?: boolean
  isWhiteGloveDelivery?: boolean
  eddDetails?: EDDDetails
  isVitamin?: boolean
  optionValueCount: number
  socialProofData?: TSocialProofData
  isOOS?: boolean
}) {
  const eddLabel = generateEDDLabel(eddDetails)

  const { experimentBucket: urgencyTagsBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.URGENCY_TAGS)

  const showUrgencyTags =
    urgencyTagsBucket !== STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.URGENCY_TAGS].buckets?.control

  return (
    <>
      {isVitamin && optionValueCount > 1 && (
        <div className={classNames(styles.bottomTag, styles.vitaminOptions)}>
          Available in {optionValueCount || 5} flavors
        </div>
      )}
      {showUrgencyTags && socialProofData?.soldRecentlyTag && (
        <div className={styles.soldRecentlyTag}>{socialProofData.soldRecentlyTag}</div>
      )}
      {eddLabel && <div className={classNames(styles.bottomTag, styles.eddLabel)}>{eddLabel}</div>}
      {isWhiteGloveDelivery ? <div className={styles.whiteglove}>Free white glove delivery</div> : null}
      {isPreorder ? <div className={classNames(styles.bottomTag, styles.preorder)}>PREORDER</div> : null}
      {showUrgencyTags && socialProofData?.stockTag && !isOOS && (
        <div className={styles.stockTag}>{socialProofData.stockTag}</div>
      )}
    </>
  )
}
